/* ───────────────────── CSV PARSER ─────────────────────
   Quote-aware. Auto-detects comma vs tab (Excel/Sheets paste).
   Returns an array of rows, each an array of cell strings.
   Fully-empty rows are dropped. */
export function parseCsv(text) {
  if (!text) return [];
  text = text.replace(/^﻿/, ""); // strip BOM

  // Delimiter detection from the first line: tab if it has more tabs than commas.
  const nl = text.indexOf("\n");
  const firstLine = nl === -1 ? text : text.slice(0, nl);
  const delim = firstLine.split("\t").length > firstLine.split(",").length ? "\t" : ",";

  const rows = [];
  let row = [];
  let field = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; } // escaped quote
        else inQuotes = false;
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === delim) {
      row.push(field); field = "";
    } else if (c === "\n") {
      row.push(field); rows.push(row); row = []; field = "";
    } else if (c !== "\r") {
      field += c;
    }
  }
  if (field !== "" || row.length > 0) { row.push(field); rows.push(row); }

  return rows.filter((r) => r.some((cell) => cell.trim() !== ""));
}
